import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

import { useEffect, useState } from 'react'

type Props = {
  action: Function
}

const DeleteTemplateModal = ({ action }: Props) => {
  const [open, setOpen] = useState<boolean>(false)


  const executeAction = async () => {
    await action()
    setOpen(false)
  }

  return (
    <div>
      <IconButton aria-label="delete" onClick={() => setOpen(true)}>
        <DeleteIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {'Borrar la plantilla?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Esta accion es irreversible
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button onClick={() => executeAction()} autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DeleteTemplateModal
